module.exports = __webpack_public_path__ + "static/media/OS.5f0e820d.pdf";